import React, { Fragment } from "react"

import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"
import Tags from "../../../common/tags/Tags"
import TagItem from "../../../common/tags/TagItem"

const CommunityViewRelatedItems = ({
    topics,
    dimensions,
    communities,
    projects,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            {topics &&
                topics.length > 0 && (
                    <Fragment>
                        <h3 className="first-heading">
                            <span className="icon icon-insights" />
                            Insight areas
                        </h3>
                        <Tags className="clearfix">
                            {topics.map(({ id, name }) => (
                                <TagItem isGrey={true} key={id}>
                                    {name}
                                </TagItem>
                            ))}
                        </Tags>
                    </Fragment>
                )}
            {dimensions &&
                dimensions.length > 0 && (
                    <Fragment>
                        <h3 className={!topics.length ? "first-heading" : ""}>
                            <span className="icon icon-insights" />
                            Key issues
                        </h3>
                        <Tags className="clearfix">
                            {dimensions.map(({ id, name }) => (
                                <TagItem key={id} isGrey={true}>
                                    {name}
                                </TagItem>
                            ))}
                        </Tags>
                    </Fragment>
                )}
            {communities &&
                communities.length > 0 && (
                    <Fragment>
                        <h3
                            className={
                                !topics.length && !dimensions.length
                                    ? "first-heading"
                                    : ""
                            }
                        >
                            <span className="icon icon-community" />
                            Communities
                        </h3>
                        <Tags className="clearfix">
                            {communities.map(({ id, name }) => (
                                <TagItem key={id} isGrey={true}>
                                    {name}
                                </TagItem>
                            ))}
                        </Tags>
                    </Fragment>
                )}
            {projects &&
                projects.length > 0 && (
                    <Fragment>
                        <h3
                            className={
                                !topics.length &&
                                !dimensions.length &&
                                !communities.length
                                    ? "first-heading"
                                    : ""
                            }
                        >
                            <span className="icon icon-concepts" />
                            Projects
                        </h3>
                        <Tags className="clearfix">
                            {projects.map(({ id, name, title }) => (
                                <TagItem key={id} isGrey={true}>
                                    {name || title}
                                </TagItem>
                            ))}
                        </Tags>
                    </Fragment>
                )}
            {(isFetching ||
                ((topics || []).length <= 0 &&
                    (dimensions || []).length <= 0 &&
                    (communities || []).length <= 0 &&
                    (projects || []).length <= 0)) && (
                <h3 className="first-heading">
                    <span className="icon icon-concepts" />Related
                </h3>
            )}
            {isFetching ? (
                <ContentLoaderTags isFetching={isFetching} lines={3} />
            ) : (
                (topics || []).length <= 0 &&
                (dimensions || []).length <= 0 &&
                (communities || []).length <= 0 &&
                (projects || []).length <= 0 && <span>No related content</span>
            )}
        </div>
    </div>
)

export default CommunityViewRelatedItems
